import { Outlet } from "react-router-dom";
import { Navbar } from "../components";
import { Footer } from "../container";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import Analytics from "../components/Analytics/Analytics";

const MainLayout = () => {
    return (
        <div>
            <Analytics />
            <Navbar />
            <Outlet />
            <ScrollToTop />
            <Footer />
        </div>
    );
};

export default MainLayout;